import React from 'react';
import { string } from 'prop-types';
import Panel from '../Panel';
import Icon from '../../images/info.svg';
import { InfoWrapper, InfoIcon } from './styles';

export const InfoPanel = ({ type, message }) => (
  <Panel type={type}>
    <InfoWrapper>
      <InfoIcon>
        <img src={Icon} alt="" />
      </InfoIcon>
      <span> {`${message} `} </span>
    </InfoWrapper>
  </Panel>
);

InfoPanel.propTypes = {
  type: string.isRequired,
  message: string.isRequired,
};

export default InfoPanel;
